import styled from "styled-components"

const EstimatesContainer = styled.div`
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  box-sizing: border-box;
  margin-top: 2.5rem;
  margin-bottom: 1rem;
  width: 100%;
`

export { EstimatesContainer }
